import { z } from "zod";
import { defineMutation } from "supabase/database/server.ts";
import { api, ApiResponse } from "supabase/database/api.ts";


export const RecoverPassword = defineMutation({
  input: z.object({ newPassword: z.string() }),
  handler: async ({ db }, { newPassword }) => {
    const { data, error } = await db
      .auth
      .updateUser({ password: newPassword })
    if (error) return {
        status: false,
        data: null,
        error: error.message
    } as ApiResponse<string>;

    return {
        status: true,
        data: data,
        error: null
    } as ApiResponse<typeof data>;
  },
});

export const ResetPassword = defineMutation({
  input: z.object({ reg_num: z.string() }),
  handler: async ({ db }, { reg_num }) => {
    const user = await api.authQueries.getUserData({ reg_num });
    if (user.length > 0){
        const email = user[0].email;
        const { data, error } = await db
            .auth
            .resetPasswordForEmail(email, {
                redirectTo: `${process.env.REACT_APP_PROD_URL}/reset-password`
            });

        if (error) return {
            status: false,
            data: null,
            error: error.message
        } as ApiResponse<string>;
        
        return {
            status: true,
            data: data,
            error: null
        } as ApiResponse<typeof data>;
    }

    return {
        status: false,
        data: null,
        error: "Couldn't find that user"
    } as ApiResponse<string>;
  },
});

export const UpdateEmail = defineMutation({
    input: z.object({
        email: z.email(),
        scj_id: z.string()
    }),
    handler: async ({ db }, { email, scj_id }) => {
        const { data: _, error } = await db
            .from('access_report')
            .update({ email: email })
            .eq('registration_number', scj_id)
            .select();
        if (error) throw error;
    }
})

export const UpdateUserInfo = defineMutation({
    input: z.object({
        email: z.email(),
        formData: z.record(z.any(), z.any())
    }),
    handler: async ({ db }, { email, formData }) => {
        const { data: _, error } = await db
            .from('access_report')
            .update({ ...formData })
            .eq('email', email)
            .select();
        if (error) throw error;
    }
})

export const CreateBasicInfoUpdate = defineMutation({
    input: z.object({
        email: z.email(),
        formData: z.record(z.any(), z.any())
    }),
    handler: async ({ db }, { email, formData }) => {
        const { data: _, error } = await db
            .from('basic_info_updates')
            .insert({ ...formData, user_email: email, status: 'pending' })
            .select();
        if (error) throw error;
    }
})